import React from 'react';
import ReportsHeader from '../../Common/ReportsHeader/ReportsHeader';
import Loader from '../../Common/Loader/Loader';
import { firebaseApp } from '../../../js/firebase';
import { getFirestore, collection, addDoc, getDocs, doc, updateDoc, deleteDoc, query, orderBy } from 'firebase/firestore';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/AddCircle';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Chip from '@mui/material/Chip';
import Autocomplete from '@mui/material/Autocomplete';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import './IngredientsRecipes.css';

const db = getFirestore(firebaseApp);

const StyledTabs = styled((props) => (
  <Tabs
    {...props}
    TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
  />
))({
  '& .MuiTabs-indicator': {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    height:'5px'
  },
  '& .MuiTabs-indicatorSpan': {
    maxWidth: 40,
    width: '100%',
    backgroundColor: '#91BCB9',
  },
});

const StyledTab = styled((props) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    textTransform: 'none',
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.pxToRem(15),
    marginRight: theme.spacing(1),
    color: 'rgba(255, 255, 255, 0.7)',
    '&.Mui-selected': {
      color: '#fff',
    },
    '&.Mui-focusVisible': {
      backgroundColor: '#008080',
    },
  }),
);

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: "100%",
  maxWidth: 600,
  maxHeight:'80vh',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  overflowY:'auto',
  p: 4,
};

class IngredientsRecipes extends React.Component {
    
    constructor(props){
        super(props);
        this.state = {
            tabValue: 0,
            ingredients: [],
            recipes: [],
            loadingIngredients: false,
            loadingRecipes: false,
            showIngredientModal: false,
            showRecipeModal: false,
            editingIngredient: null,
            editingRecipe: null,
            ingredientForm: {
                sku: '',
                name: '',
                units: '',
                batchSize: ''
            },
            recipeForm: {
                name: '',
                yield: '',
                yieldUnit: 'g',
                ingredients: []
            },
            fieldErrors: {},
            selectedIngredientForRecipe: null,
            selectedIngredientQuantity: ''
        }
    }

    componentDidMount(){
        this.loadIngredients();
        this.loadRecipes();
    }

    loadIngredients = async () => {
        this.setState({ loadingIngredients: true });
        try {
            const ingredientsRef = collection(db, 'ingredients');
            const q = query(ingredientsRef, orderBy('name'));
            const querySnapshot = await getDocs(q);
            const ingredients = [];
            querySnapshot.forEach((doc) => {
                ingredients.push({ id: doc.id, ...doc.data() });
            });
            this.setState({ ingredients, loadingIngredients: false });
        } catch (error) {
            console.error('Error loading ingredients:', error);
            this.setState({ loadingIngredients: false });
        }
    }

    loadRecipes = async () => {
        this.setState({ loadingRecipes: true });
        try {
            const recipesRef = collection(db, 'recipes');
            const q = query(recipesRef, orderBy('name'));
            const querySnapshot = await getDocs(q);
            const recipes = [];
            querySnapshot.forEach((doc) => {
                recipes.push({ id: doc.id, ...doc.data() });
            });
            this.setState({ recipes, loadingRecipes: false });
        } catch (error) {
            console.error('Error loading recipes:', error);
            this.setState({ loadingRecipes: false });
        }
    }

    handleTabChange = (event, newValue) => {
        this.setState({ tabValue: newValue });
    }

    // Ingredient methods
    openIngredientModal = (ingredient = null) => {
        if (ingredient) {
            this.setState({
                editingIngredient: ingredient,
                ingredientForm: {
                    sku: ingredient.sku || '',
                    name: ingredient.name || '',
                    units: ingredient.units || '',
                    batchSize: ingredient.batchSize || ''
                },
                showIngredientModal: true,
                fieldErrors: {}
            });
        } else {
            this.setState({
                editingIngredient: null,
                ingredientForm: {
                    sku: '',
                    name: '',
                    units: '',
                    batchSize: ''
                },
                showIngredientModal: true,
                fieldErrors: {}
            });
        }
    }

    closeIngredientModal = () => {
        this.setState({
            showIngredientModal: false,
            editingIngredient: null,
            ingredientForm: {
                sku: '',
                name: '',
                units: '',
                batchSize: ''
            },
            fieldErrors: {}
        });
    }

    handleIngredientFieldChange = (field, e) => {
        const value = e.target.value;
        const fieldErrors = { ...this.state.fieldErrors };
        delete fieldErrors[field];
        this.setState({
            ingredientForm: {
                ...this.state.ingredientForm,
                [field]: value
            },
            fieldErrors
        });
    }

    validateIngredientForm = () => {
        const errors = {};
        const { sku, name, units, batchSize } = this.state.ingredientForm;

        if (!sku || sku.trim() === '') {
            errors.sku = 'SKU is required';
        }
        if (!name || name.trim() === '') {
            errors.name = 'Name is required';
        }
        if (!units || units.trim() === '') {
            errors.units = 'Units is required';
        }
        if (!batchSize || batchSize.trim() === '' || isNaN(batchSize) || parseFloat(batchSize) <= 0) {
            errors.batchSize = 'Batch size must be a positive number';
        }

        if (Object.keys(errors).length > 0) {
            this.setState({ fieldErrors: errors });
            return false;
        }
        return true;
    }

    saveIngredient = async () => {
        if (!this.validateIngredientForm()) {
            return;
        }

        try {
            const ingredientData = {
                sku: this.state.ingredientForm.sku.trim(),
                name: this.state.ingredientForm.name.trim(),
                units: this.state.ingredientForm.units.trim(),
                batchSize: parseFloat(this.state.ingredientForm.batchSize)
            };

            if (this.state.editingIngredient) {
                const ingredientRef = doc(db, 'ingredients', this.state.editingIngredient.id);
                await updateDoc(ingredientRef, ingredientData);
            } else {
                await addDoc(collection(db, 'ingredients'), ingredientData);
            }

            this.closeIngredientModal();
            this.loadIngredients();
        } catch (error) {
            console.error('Error saving ingredient:', error);
            alert('Error saving ingredient. Please try again.');
        }
    }

    deleteIngredient = async (ingredientId) => {
        if (window.confirm('Are you sure you want to delete this ingredient?')) {
            try {
                await deleteDoc(doc(db, 'ingredients', ingredientId));
                this.loadIngredients();
            } catch (error) {
                console.error('Error deleting ingredient:', error);
                alert('Error deleting ingredient. Please try again.');
            }
        }
    }

    // Recipe methods
    openRecipeModal = (recipe = null) => {
        if (recipe) {
            this.setState({
                editingRecipe: recipe,
                recipeForm: {
                    name: recipe.name || '',
                    yield: recipe.yield || '',
                    yieldUnit: recipe.yieldUnit || 'g',
                    ingredients: recipe.ingredients || []
                },
                showRecipeModal: true,
                fieldErrors: {},
                selectedIngredientForRecipe: null,
                selectedIngredientQuantity: ''
            });
        } else {
            this.setState({
                editingRecipe: null,
                recipeForm: {
                    name: '',
                    yield: '',
                    yieldUnit: 'g',
                    ingredients: []
                },
                showRecipeModal: true,
                fieldErrors: {},
                selectedIngredientForRecipe: null,
                selectedIngredientQuantity: ''
            });
        }
    }

    closeRecipeModal = () => {
        this.setState({
            showRecipeModal: false,
            editingRecipe: null,
            recipeForm: {
                name: '',
                yield: '',
                yieldUnit: 'g',
                ingredients: []
            },
            fieldErrors: {},
            selectedIngredientForRecipe: null,
            selectedIngredientQuantity: ''
        });
    }

    handleRecipeFieldChange = (field, e) => {
        const value = e.target.value;
        const fieldErrors = { ...this.state.fieldErrors };
        delete fieldErrors[field];
        this.setState({
            recipeForm: {
                ...this.state.recipeForm,
                [field]: value
            },
            fieldErrors
        });
    }

    handleAddIngredientToRecipe = () => {
        const { selectedIngredientForRecipe, selectedIngredientQuantity, recipeForm } = this.state;
        
        if (!selectedIngredientForRecipe) {
            alert('Please select an ingredient');
            return;
        }

        if (!selectedIngredientQuantity || isNaN(selectedIngredientQuantity) || parseFloat(selectedIngredientQuantity) <= 0) {
            alert('Please enter a valid quantity');
            return;
        }

        // Check if ingredient already added
        if (recipeForm.ingredients.find(ing => ing.id === selectedIngredientForRecipe.id)) {
            alert('This ingredient is already added to the recipe');
            return;
        }

        const newIngredient = {
            id: selectedIngredientForRecipe.id,
            name: selectedIngredientForRecipe.name,
            sku: selectedIngredientForRecipe.sku,
            quantity: parseFloat(selectedIngredientQuantity),
            units: selectedIngredientForRecipe.units
        };

        this.setState({
            recipeForm: {
                ...this.state.recipeForm,
                ingredients: [...recipeForm.ingredients, newIngredient]
            },
            selectedIngredientForRecipe: null,
            selectedIngredientQuantity: ''
        });
    }

    removeIngredientFromRecipe = (ingredientId) => {
        const { recipeForm } = this.state;
        this.setState({
            recipeForm: {
                ...this.state.recipeForm,
                ingredients: recipeForm.ingredients.filter(ing => ing.id !== ingredientId)
            }
        });
    }

    validateRecipeForm = () => {
        const errors = {};
        const { name, yield: recipeYield, ingredients } = this.state.recipeForm;

        if (!name || name.trim() === '') {
            errors.name = 'Recipe name is required';
        }
        if (!recipeYield || recipeYield.trim() === '' || isNaN(recipeYield) || parseFloat(recipeYield) <= 0) {
            errors.yield = 'Yield must be a positive number';
        }
        if (!ingredients || ingredients.length === 0) {
            errors.ingredients = 'At least one ingredient is required';
        }

        if (Object.keys(errors).length > 0) {
            this.setState({ fieldErrors: errors });
            return false;
        }
        return true;
    }

    saveRecipe = async () => {
        if (!this.validateRecipeForm()) {
            return;
        }

        try {
            const recipeData = {
                name: this.state.recipeForm.name.trim(),
                yield: parseFloat(this.state.recipeForm.yield),
                yieldUnit: this.state.recipeForm.yieldUnit,
                ingredients: this.state.recipeForm.ingredients
            };

            if (this.state.editingRecipe) {
                const recipeRef = doc(db, 'recipes', this.state.editingRecipe.id);
                await updateDoc(recipeRef, recipeData);
            } else {
                await addDoc(collection(db, 'recipes'), recipeData);
            }

            this.closeRecipeModal();
            this.loadRecipes();
        } catch (error) {
            console.error('Error saving recipe:', error);
            alert('Error saving recipe. Please try again.');
        }
    }

    deleteRecipe = async (recipeId) => {
        if (window.confirm('Are you sure you want to delete this recipe?')) {
            try {
                await deleteDoc(doc(db, 'recipes', recipeId));
                this.loadRecipes();
            } catch (error) {
                console.error('Error deleting recipe:', error);
                alert('Error deleting recipe. Please try again.');
            }
        }
    }

    renderIngredientsTable() {
        const { ingredients, loadingIngredients } = this.state;

        return (
            <Box>
                <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 0, bgcolor: '#fafafa', px: 2, py: 1.5, borderRadius: 1 }}>
                    <Typography variant="h5" component="h2">
                        Ingredients
                    </Typography>
                    <Button 
                        color="success" 
                        variant="contained" 
                        startIcon={<AddIcon />}
                        onClick={() => this.openIngredientModal()}
                    >
                        Add Ingredient
                    </Button>
                </Stack>

                <TableContainer component={Paper} sx={{ bgcolor: '#fff' }}>
                    <Table sx={{ minWidth: 650 }} aria-label="ingredients table" stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 'bold', background: '#47908a', color: '#FFF' }}>SKU</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', background: '#47908a', color: '#FFF' }}>Name</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', background: '#47908a', color: '#FFF' }}>Units</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', background: '#47908a', color: '#FFF' }}>Batch Size</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', background: '#47908a', color: '#FFF' }}>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {loadingIngredients ? (
                                <TableRow>
                                    <TableCell colSpan={5} sx={{ textAlign: 'center' }}>
                                        <Loader />
                                    </TableCell>
                                </TableRow>
                            ) : ingredients.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={5} sx={{ textAlign: 'center' }}>
                                        <Typography>No ingredients found. Add your first ingredient!</Typography>
                                    </TableCell>
                                </TableRow>
                            ) : (
                                ingredients.map((ingredient) => (
                                    <TableRow key={ingredient.id}>
                                        <TableCell>{ingredient.sku}</TableCell>
                                        <TableCell>{ingredient.name}</TableCell>
                                        <TableCell>{ingredient.units}</TableCell>
                                        <TableCell>{ingredient.batchSize}</TableCell>
                                        <TableCell>
                                            <Stack spacing={1} direction="row">
                                                <Button 
                                                    color="primary" 
                                                    variant="outlined" 
                                                    size="small"
                                                    startIcon={<EditIcon />}
                                                    onClick={() => this.openIngredientModal(ingredient)}
                                                >
                                                    Edit
                                                </Button>
                                                <Button 
                                                    color="error" 
                                                    variant="outlined" 
                                                    size="small"
                                                    startIcon={<DeleteIcon />}
                                                    onClick={() => this.deleteIngredient(ingredient.id)}
                                                >
                                                    Delete
                                                </Button>
                                            </Stack>
                                        </TableCell>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        );
    }

    renderRecipesTable() {
        const { recipes, loadingRecipes } = this.state;

        return (
            <Box>
                <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 0, bgcolor: '#fafafa', px: 2, py: 1.5, borderRadius: 1 }}>
                    <Typography variant="h5" component="h2">
                        Housemade Recipes
                    </Typography>
                    <Button 
                        color="success" 
                        variant="contained" 
                        startIcon={<AddIcon />}
                        onClick={() => this.openRecipeModal()}
                    >
                        Add Recipe
                    </Button>
                </Stack>

                <TableContainer component={Paper} sx={{ bgcolor: '#fff' }}>
                    <Table sx={{ minWidth: 650 }} aria-label="recipes table" stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 'bold', background: '#47908a', color: '#FFF' }}>Name</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', background: '#47908a', color: '#FFF' }}>Ingredients</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', background: '#47908a', color: '#FFF' }}>Yield</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', background: '#47908a', color: '#FFF' }}>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {loadingRecipes ? (
                                <TableRow>
                                    <TableCell colSpan={4} sx={{ textAlign: 'center' }}>
                                        <Loader />
                                    </TableCell>
                                </TableRow>
                            ) : recipes.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={4} sx={{ textAlign: 'center' }}>
                                        <Typography>No recipes found. Add your first recipe!</Typography>
                                    </TableCell>
                                </TableRow>
                            ) : (
                                recipes.map((recipe) => (
                                    <TableRow key={recipe.id}>
                                        <TableCell>
                                            <Typography variant="subtitle1" fontWeight="bold">
                                                {recipe.name}
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            <Stack direction="row" spacing={1} flexWrap="wrap">
                                                {recipe.ingredients && recipe.ingredients.map((ing, idx) => (
                                                    <Typography key={idx} variant="body2">
                                                        {ing.quantity} {ing.units} {ing.name}
                                                        {idx < recipe.ingredients.length - 1 ? ',' : ''}
                                                    </Typography>
                                                ))}
                                            </Stack>
                                        </TableCell>
                                        <TableCell>
                                            {recipe.yield} {recipe.yieldUnit || 'g'}
                                        </TableCell>
                                        <TableCell>
                                            <Stack spacing={1} direction="row">
                                                <Button 
                                                    color="primary" 
                                                    variant="outlined" 
                                                    size="small"
                                                    startIcon={<EditIcon />}
                                                    onClick={() => this.openRecipeModal(recipe)}
                                                >
                                                    Edit
                                                </Button>
                                                <Button 
                                                    color="error" 
                                                    variant="outlined" 
                                                    size="small"
                                                    startIcon={<DeleteIcon />}
                                                    onClick={() => this.deleteRecipe(recipe.id)}
                                                >
                                                    Delete
                                                </Button>
                                            </Stack>
                                        </TableCell>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        );
    }

    render() {
        const { tabValue, showIngredientModal, showRecipeModal, ingredientForm, recipeForm, fieldErrors, ingredients, selectedIngredientForRecipe, selectedIngredientQuantity } = this.state;

        return (
            <div className='ingredientsRecipesContainer'>
                <ReportsHeader />
                <div className='ingredientsRecipesContent'>
                <Box sx={{ padding: 3 }}>
                    <Box sx={{ flexGrow: 1, bgcolor: '#008080', display: 'flex', mb: 0 }}>
                        <StyledTabs
                            value={tabValue}
                            onChange={this.handleTabChange}
                            aria-label="ingredients and recipes tabs"
                        >
                            <StyledTab label="Ingredients" />
                            <StyledTab label="Recipes" />
                        </StyledTabs>
                    </Box>

                    <TabPanel value={tabValue} index={0}>
                        {this.renderIngredientsTable()}
                    </TabPanel>

                    <TabPanel value={tabValue} index={1}>
                        {this.renderRecipesTable()}
                    </TabPanel>

                    {/* Ingredient Modal */}
                    <Modal
                        open={showIngredientModal}
                        onClose={this.closeIngredientModal}
                        aria-labelledby="ingredient-modal-title"
                        aria-describedby="ingredient-modal-description"
                    >
                        <Box sx={modalStyle}>
                            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
                                <Typography id="ingredient-modal-title" variant="h6" component="h2">
                                    {this.state.editingIngredient ? 'Edit Ingredient' : 'Add New Ingredient'}
                                </Typography>
                                <IconButton onClick={this.closeIngredientModal}>
                                    <CloseIcon />
                                </IconButton>
                            </Stack>

                            <Stack spacing={2}>
                                <TextField
                                    label="SKU"
                                    value={ingredientForm.sku}
                                    onChange={(e) => this.handleIngredientFieldChange('sku', e)}
                                    error={!!fieldErrors.sku}
                                    helperText={fieldErrors.sku}
                                    fullWidth
                                    required
                                />
                                <TextField
                                    label="Name"
                                    value={ingredientForm.name}
                                    onChange={(e) => this.handleIngredientFieldChange('name', e)}
                                    error={!!fieldErrors.name}
                                    helperText={fieldErrors.name}
                                    fullWidth
                                    required
                                />
                                <TextField
                                    label="Units"
                                    value={ingredientForm.units}
                                    onChange={(e) => this.handleIngredientFieldChange('units', e)}
                                    error={!!fieldErrors.units}
                                    helperText={fieldErrors.units}
                                    placeholder="e.g., g, kg, ml, L"
                                    fullWidth
                                    required
                                />
                                <TextField
                                    label="Batch Size"
                                    type="number"
                                    value={ingredientForm.batchSize}
                                    onChange={(e) => this.handleIngredientFieldChange('batchSize', e)}
                                    error={!!fieldErrors.batchSize}
                                    helperText={fieldErrors.batchSize}
                                    fullWidth
                                    required
                                />

                                <Stack direction="row" spacing={2} justifyContent="flex-end" sx={{ mt: 2 }}>
                                    <Button color="error" variant="outlined" onClick={this.closeIngredientModal}>
                                        Cancel
                                    </Button>
                                    <Button color="success" variant="contained" onClick={this.saveIngredient}>
                                        {this.state.editingIngredient ? 'Update' : 'Save'}
                                    </Button>
                                </Stack>
                            </Stack>
                        </Box>
                    </Modal>

                    {/* Recipe Modal */}
                    <Modal
                        open={showRecipeModal}
                        onClose={this.closeRecipeModal}
                        aria-labelledby="recipe-modal-title"
                        aria-describedby="recipe-modal-description"
                    >
                        <Box sx={modalStyle}>
                            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
                                <Typography id="recipe-modal-title" variant="h6" component="h2">
                                    {this.state.editingRecipe ? 'Edit Recipe' : 'Add New Recipe'}
                                </Typography>
                                <IconButton onClick={this.closeRecipeModal}>
                                    <CloseIcon />
                                </IconButton>
                            </Stack>

                            <Stack spacing={2}>
                                <TextField
                                    label="Recipe Name"
                                    value={recipeForm.name}
                                    onChange={(e) => this.handleRecipeFieldChange('name', e)}
                                    error={!!fieldErrors.name}
                                    helperText={fieldErrors.name}
                                    fullWidth
                                    required
                                />

                                <Stack direction="row" spacing={2}>
                                    <TextField
                                        label="Yield"
                                        type="number"
                                        value={recipeForm.yield}
                                        onChange={(e) => this.handleRecipeFieldChange('yield', e)}
                                        error={!!fieldErrors.yield}
                                        helperText={fieldErrors.yield}
                                        fullWidth
                                        required
                                    />
                                    <FormControl fullWidth>
                                        <InputLabel>Yield Unit</InputLabel>
                                        <Select
                                            value={recipeForm.yieldUnit}
                                            label="Yield Unit"
                                            onChange={(e) => this.handleRecipeFieldChange('yieldUnit', e)}
                                        >
                                            <MenuItem value="g">g</MenuItem>
                                            <MenuItem value="kg">kg</MenuItem>
                                            <MenuItem value="ml">ml</MenuItem>
                                            <MenuItem value="L">L</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Stack>

                                <Box sx={{ border: '1px solid #ccc', borderRadius: 1, p: 2, mt: 2 }}>
                                    <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 'bold' }}>
                                        Add Ingredients
                                    </Typography>
                                    <Stack spacing={2}>
                                        <Autocomplete
                                            options={ingredients}
                                            getOptionLabel={(option) => `${option.name} (${option.sku})`}
                                            value={selectedIngredientForRecipe}
                                            onChange={(event, newValue) => {
                                                this.setState({ selectedIngredientForRecipe: newValue });
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Select Ingredient"
                                                    placeholder="Search ingredients..."
                                                />
                                            )}
                                            fullWidth
                                        />
                                        <Stack direction="row" spacing={2}>
                                            <TextField
                                                label="Quantity"
                                                type="number"
                                                value={selectedIngredientQuantity}
                                                onChange={(e) => this.setState({ selectedIngredientQuantity: e.target.value })}
                                                fullWidth
                                            />
                                            <Button 
                                                color="primary" 
                                                variant="contained" 
                                                onClick={this.handleAddIngredientToRecipe}
                                                disabled={!selectedIngredientForRecipe || !selectedIngredientQuantity}
                                            >
                                                Add
                                            </Button>
                                        </Stack>
                                    </Stack>

                                    {recipeForm.ingredients.length > 0 && (
                                        <Box sx={{ mt: 2 }}>
                                            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 'bold' }}>
                                                Recipe Ingredients:
                                            </Typography>
                                            <Stack spacing={1}>
                                                {recipeForm.ingredients.map((ing) => (
                                                    <Chip
                                                        key={ing.id}
                                                        label={`${ing.quantity} ${ing.units} ${ing.name}`}
                                                        onDelete={() => this.removeIngredientFromRecipe(ing.id)}
                                                        color="primary"
                                                        variant="outlined"
                                                    />
                                                ))}
                                            </Stack>
                                            {fieldErrors.ingredients && (
                                                <Typography color="error" variant="caption" sx={{ mt: 1, display: 'block' }}>
                                                    {fieldErrors.ingredients}
                                                </Typography>
                                            )}
                                        </Box>
                                    )}
                                </Box>

                                <Stack direction="row" spacing={2} justifyContent="flex-end" sx={{ mt: 2 }}>
                                    <Button color="error" variant="outlined" onClick={this.closeRecipeModal}>
                                        Cancel
                                    </Button>
                                    <Button color="success" variant="contained" onClick={this.saveRecipe}>
                                        {this.state.editingRecipe ? 'Update' : 'Save'}
                                    </Button>
                                </Stack>
                            </Stack>
                        </Box>
                    </Modal>
                </Box>
                </div>
            </div>
        );
    }
}

export default IngredientsRecipes;

